<template>
    <div>
        <vs-prompt @cancel="val=''" blur @accept="acceptAlert" @close="close" :active.sync="activePrompt"
            accept-text="Add" title="Add/Edit Slider">
            <div class="con-exemple-prompt">
                <vs-input placeholder="Title" v-model="slider.title" />
                <input type="file" class="form-control-file" ref="file" placeholder="" aria-describedby="fileHelpId" v-on:change="handleFile()">
                <vSelect :filterable="false" :multiple="false" v-model="slider.movie_id" @search="search" :options="$store.state.movies.search" placeholder="Select Movie">

                    <template slot="option" slot-scope="option">
                        <div class="d-center">
                            <img :src="`${$baseUrl}/uploads/movies/thumbs/${option.poster}`" />
                            {{ option.en_title }} - {{ option.year }}
                        </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                            <img :src="`${$baseUrl}/uploads/movies/thumbs/${option.poster}`" />
                            {{ option.en_title }}
                        </div>
                    </template>
                </vSelect>
            </div>
        </vs-prompt>
        <vs-table :data="$store.state.slider.all.data">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div class="flex flex-wrap-reverse items-center">
                    <vs-button color="primary" type="border" @click="activePrompt = true;slider =def_slider">
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" /> Add New Slide</vs-button>
                </div>
            </div>
            <template #thead>
                <vs-th>Title</vs-th>
                <vs-th>Movie</vs-th>
                <vs-th>Actions</vs-th>
            </template>
            <template slot-scope="{data}">
                <tbody>
                    <vs-tr v-for="(slide,index) in data" :key="index">
                        <vs-td>{{slide.banner}}</vs-td>
                        <vs-td>0</vs-td>
                        <vs-td class="whitespace-no-wrap">
                            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                @click="edit(slide)" />
                            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                class="ml-2" @click="openConfirm(slide)" />
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>
    </div>
</template>
<script>
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';
    export default {
        components: {
            vSelect
        },
        data() {
            return {
                select1: 2,
                activePrompt: false,
                delConfirm: false,
                val: '',
                movies: [],
                def_slider: {
                    id: 0,
                    title: '',
                    banner: '',
                    movie_id:[],
                },
                slider: {
                    id: 0,
                    title: '',
                    banner: '',
                    movie_id:[],
                }
            }
        },
        created() {
            this.$store.dispatch('slider/fetchSliders')
        },
        methods: {
            search(query, loading) {
                this.$store.dispatch('movies/search', query)
            },
            openConfirm(group) {
                this.slider = slider;
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Delete Slider`,
                    text: 'Are you sure to delete this item ?',
                    accept: this.del,
                    close: this.close
                })
            },
            acceptAlert(color) {
                const data = new FormData();
                data.append('id', this.slider.id);
                data.append('title', this.slider.title);
                data.append('banner', this.slider.banner);
                this.axios.post(`${this.$baseUrl}/api/slider`, data).then(res => {
                    this.slider = this.def_slider;
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'success',
                            title: 'group Addedd',
                            text: res.data.response.title
                        })
                    }
                    this.$store.dispatch('slider/fetchSliders')
                })

            },
            close() {
                this.slider = this.def_slider;
            },
            edit(slider) {
                this.slider = slider;
                this.activePrompt = true;
            },
            handleFile() {
                this.slider.banner = this.$refs.file.files[0];
            },
            del() {
                this.axios.post(`${this.$baseUrl}/api/slider/delete/${this.slider.id}`).then(res => {
                    this.slider = this.def_slider;
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'warning',
                            title: 'Slider Deleted !',
                            text: res.data.response.title
                        })
                    }
                    this.$store.dispatch('slider/fetchSliders')
                })

            },
        }
    }
</script>
<style lang="scss" scoped>
    .con-exemple-prompt {
        padding: 10px;
        padding-bottom: 0px;

        .vs-input {
            width: 100%;
            margin-top: 10px;
        }

        .v-select {
            width: 100%;
            margin-top: 10px;
        }

    }

    img {
        height: auto;
        max-width: 2.5rem;
        margin-right: 1rem;
    }

    .d-center {
        display: flex;
        align-items: center;
    }

    .selected img {
        width: auto;
        max-height: 23px;
        margin-right: 0.5rem;
    }
</style>